import Cookies from "js-cookie";

import type { TriggerPointCookiePayload } from "@/types/trigger-point-cookie";

const TRIGGER_POINT_COOKIE_NAME = "trigger_point";

const COOKIE_OPTS = {
  expires: 1,
  secure: true,
  sameSite: "Strict" as const
};

export function setTriggerPointCookie(
  payload: TriggerPointCookiePayload
): void {
  Cookies.set(TRIGGER_POINT_COOKIE_NAME, JSON.stringify(payload), COOKIE_OPTS);
}
